import isEmpty from "lodash/isEmpty";
import { orderServiceInstance as axiosInstance } from "@stadium/services/axios";

import { jsonDataFormatter } from "@stadium/helpers/formatter";
import { getJsonCookie } from "@stadium/helpers/cookie";

import { authActions } from "@stadium/redux-utils/slices";

const emptyObj = {};
const emptyArr = {};

const formatAndUpdateStoredUser = (res) => (dispatch) => {
  const responseData = jsonDataFormatter(res);
  const { spreeUsers = emptyObj, spreeCorporateAccounts = emptyObj } = responseData || emptyObj;
  const extractedUserData = Object.values(spreeUsers)[0];
  const payload = {
    ...extractedUserData,
    corporateAccounts: (extractedUserData?.corporateAccountsAsOwner || emptyArr).map(
      ({ id }) => spreeCorporateAccounts[id],
    ),
  };
  dispatch(authActions.updateUser(payload));
  return payload;
};

export const updateUserGeolocationParams = (countryName) => async (dispatch) => {
  const geoCookies = getJsonCookie("geo") || emptyObj;
  const { country_code, currency_code, ip_address, fallback } = geoCookies;

  if (!countryName && !isEmpty(geoCookies) && !fallback) {
    dispatch(updateUser({ user: { currency_code, country_code, ip_address } }));
  }
};

export const updateUser = (payload) => async (dispatch) =>
  axiosInstance
    .patch("users/update", payload)
    .then((res) => dispatch(formatAndUpdateStoredUser(res)));
